import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { scrollToSection } from "../lib/useSectionNav";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Services from "../components/site/Services";
import PriceCalculator from "../components/site/PriceCalculator";
import BookingForm from "../components/site/BookingForm";
import SellDevice from "../components/site/SellDevice";
import WhyChooseUs from "../components/site/WhyChooseUs";
import About from "../components/site/About";
import Reviews from "../components/site/Reviews";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import CookieBanner from "../components/site/CookieBanner";
import LegalModal from "../components/site/LegalModal";

export default function PublicSite() {
  const [legal, setLegal] = useState(null);
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash || hash.includes("session_id=")) return;
    const t = setTimeout(() => scrollToSection(hash, "instant"), 50);
    return () => clearTimeout(t);
  }, [hash]);

  useEffect(() => {
    document.title = "MobilHub – Mobilreparasjon i Oslo | iPhone, Mac, PC og nettbrett";
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement("meta");
      m.name = "description";
      document.head.appendChild(m);
      return m;
    })();
    meta.content =
      "MobilHub tilbyr rask og pålitelig mobilreparasjon i Oslo. Skjermbytte og batteribytte for iPhone, MacBook- og PC-reparasjon, iPad-reparasjon og kjøp av brukt elektronikk. Tydelige priser og personlig service.";
  }, []);

  return (
    <div className="bg-offwhite">
      <Header />
      <main>
        <Hero />
        <Services />
        <PriceCalculator />
        <BookingForm />
        <SellDevice />
        <WhyChooseUs />
        <About />
        <Reviews />
        <Contact />
      </main>
      <Footer onOpenLegal={setLegal} />
      <CookieBanner onOpenPolicy={setLegal} />
      <LegalModal type={legal} onClose={() => setLegal(null)} />
    </div>
  );
}
